import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatTimestamp(timestamp: string): string {
  return new Date(timestamp).toLocaleTimeString();
}

export function getHealthColor(healthy: boolean): string {
  return healthy ? 'text-green-600' : 'text-red-600';
}

export function getStatusPillColor(healthyCount: number, totalCount: number): string {
  const unhealthyCount = totalCount - healthyCount;
  
  if (unhealthyCount === 0) return 'bg-green-500';
  if (unhealthyCount < 3) return 'bg-yellow-500';
  return 'bg-red-500';
}
